import { StyleSheet, Font } from "@react-pdf/renderer";


const oSans = require("../../media/PDFReport/fonts/OpenSans-Regular.ttf");
const oSansBold = require("../../media/PDFReport/fonts/OpenSans-Bold.ttf");
Font.register({ src: `${window.location.origin}/${oSans}`, family: "Open Sans" });
Font.register({ src: `${window.location.origin}/${oSansBold}`, family: "Open Sans Bold" });


// Create styles
const PDFReportStyles = StyleSheet.create({
  viewer: {
    position: 'absolute',
    top: 30,
    left: 0,
    width: '100%',
    height: '100%',
  },
  document: {},
  page: {
    backgroundColor: 'white',
  },
  headerView: {
    //backgroundColor: '#E4E4E4',
    margin: 0,
    padding: 0,
  },
  titleFrameView: {
    //backgroundColor: '#E4E4E4',
    marginLeft: 10,
    marginRight: 10,
    padding: 10,
  },
  primaryFrameView: {
    //backgroundColor: '#E4E4E4',
    marginLeft: 10,
    marginTop: 10,
    marginRight: 10,
    padding: 10,
  },
  contentView: {
    backgroundColor: 'white',
    marginTop: 1,
    marginLeft: '10px',
    marginRight: '10px',
    marginBottom: 1,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    flexGrow: 1,
  },
  tableView: {
    backgroundColor: '#e3f2fd',
    marginLeft: 0,
    marginRight: 10,
    padding: 10,
    border: 'solid',
    borderWidth: 1,
    borderColor: '#E4E4E4',
  },
  primaryText: {
    fontSize: 20,
  },
  secondaryText: {
    color: '#106EBE',
    fontSize: 16,
  },
  tableText: {
    color: 'black',
    fontSize: 9,
    marginTop: 1,
    fontFamily: 'Open Sans',
  },
  tableTextBold: {
    color: 'black',
    fontSize: 9,
    marginTop: 1,
    fontFamily: 'Open Sans Bold',
  },
  tableTextValue: {
    color: 'black',
    fontSize: 10,
  },
  imgStyle: {
    marginLeft: 'auto',
    marginRight: 'auto',
    // width:300,
    // height: 300
  },
  logoImgStyle: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 110,
  },
  sectionImgStyle: {
    marginTop: 1,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: 0,
    width: 530,
  },
  titleText: {
    color: '#0c9fcf',
    fontSize: 13,
    textDecoration: 'none',
    marginTop: 1,
    marginBottom: 1,
    fontFamily: 'Open Sans Bold',
  },
  rowView: {
    debug: true,
    display: 'flex',
    flexDirection: 'row',
  },
  colView: {
    paddingLeft: 30,
    width: '49%',
    debug: true,
    alignSelf: 'stretch',
    display: 'flex',
  },
  innerLColView: {
    width: '65%',
    debug: true,
    alignSelf: 'stretch',
    display: 'flex',
  },
  innerRColView: {
    width: '34%',
    debug: true,
    alignSelf: 'stretch',
    display: 'flex',
    wordWrap: 'breakWord',
  },
  fullColView: {
    paddingLeft: 30,
    width: '100%',
    debug: true,
    alignSelf: 'stretch',
    display: 'flex',
  },
  sectionRow: {
    display: 'flex',
    alignSelf: 'center',
    width: '70%',
    marginBottom: 5,
    border: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    paddingLeft: '10rem',
    paddingBottom: 2,
  },
  linkSection: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    marginBottom: 10,
  },
  link: {
    fontWeight: 'bold',
    textDecoration: 'none',
    color: '#0c9fcf',
  },
});

export default PDFReportStyles;



// WEBPACK FOOTER //
// ./src/components/PDFReport/pdfreport.stylesheet.js